import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_claim_ocr_company_hdr_RowClass} from '../../../dbschema';


export class ClaimOcrCompanyContainerModel extends BaseContainerModel {
  bl_aat_claim_ocr_company_hdr: bl_aat_claim_ocr_company_hdr_RowClass = new bl_aat_claim_ocr_company_hdr_RowClass();
}
